<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask" v-show="showDown">
      <div class="modal-container">
        <div>
          <div v-if="!gotList">
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <label v-if="downtimesList.length == 0" class="attentionLeft">
              {{ $t("selectDown.noDown1") }}<br />
              {{ $t("selectDown.noDown2") }}
            </label>
            <label v-else>{{ $t("selectDown.sDown") }}</label>
          </div>
          <b-table
            class="table-big-font"
            ref="selectDownTable"
            hover
            small
            selectable
            select-mode="single"
            selected-variant="success"
            sticky-header="200px"
            primary-key="_id"
            :items="downtimesList"
            :fields="showFields"
            @row-selected="onDownSelected"
          >
          </b-table>
        </div>

        <div v-if="needPsw" class="form-group">
          <label for="inputPsw">{{ $t("selectDown.password") }}</label>
          <InputText
            required
            password="true"
            id="inputPsw"
            aria-autocomplete="off"
            :autocomplete="false"
            :initInputText="initInputText"
            @handleChange="handleChange($event)"
            :placeholder="$t('selectDown.enterPsw')"
          >
          </InputText>
        </div>

        <p v-if="error" class="float-left" style="color: red">
          <b>{{ $t("selectDown.wrongPsw") }}</b>
        </p>

        <button class="btn btn-perfcell float-right marginTop40px" @click="clickCancel">
          {{ $t("selectDown.cancel") }}
        </button>

        <button v-if="saveDownEnabled" class="btn btn-perfcell float-right marginTop40px marginRight10px" @click="clickSave">
          {{ $t("selectDown.save") }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { axiosInstance } from "@/main";
import oper from "@/stores/Operations.js";
import InputText from "@/components/InputText.vue";

export default {
  name: "SelectDown",
  template: "#modal-template",
  props: {
    showDown: Boolean,
    doInitDown: Boolean,
  },
  data: function () {
    return {
      downtimesList: [],
      showFields: [
        {
          key: "text",
          label: this.$i18n.t("selectDown.texte"),
        },
      ],
      selectedDown: {},
      selectedDownId: "",
      needPsw: false,
      gotList: false,
      password: "",
      saveDownEnabled: false,
      error: false,
      initInputText: false,
    };
  },
  components: {
    InputText,
  },
  watch: {
    doInitDown: function (val) {
      if (val) {
        //console.log("----- init SelectDown");

        this.selectedDown = {};
        this.selectedDownId = "";
        this.needPsw = false;
        this.password = "";
        this.saveDownEnabled = false;

        this.downtimesList = [];
        this.$refs.selectDownTable.refresh();
        this.gotList = false;

        axiosInstance
          .get("/downtimeList/" + oper.getLineId())
          .then((resp) => {
            //console.log("----- get /downtimeList = " + JSON.stringify(resp.data, null, 2));
            this.downtimesList = resp.data;
            this.gotList = true;

            this.selectedDown = {};
            this.selectedDownId = "";
          })
          .catch((err) => {
            console.log("----- get /downtimeList error = " + JSON.stringify(err, null, 2));
          });
      }
    },
  },
  methods: {
    handleChange(payload) {
      this.password = payload;
    },
    onDownSelected(item) {
      //console.log("----- item = " + JSON.stringify(item, null, 2));
      this.error = false;
      if (item.length) {
        this.needPsw = item[0].needPsw;
        this.selectedDown = item[0];
        this.selectedDownId = item[0]._id;
        this.saveDownEnabled = true;
      }
    },
    clickSave: function () {
      if (this.needPsw) {
        let password = this.password;
        axiosInstance
          .post("/admin", { password })
          .then(() => this.saveOk())
          .catch(() => {
            this.error = true;
            this.password = "";
            this.initInputText = true;
            this.$nextTick(function () {
              this.initInputText = false;
            });
          });
      } else this.saveOk();
    },
    saveOk: function () {
      this.$emit("close", { cancel: false, selectedDown: this.selectedDown });
    },
    clickCancel: function () {
      this.$emit("close", { cancel: true });
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.modal-mask {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}
.modal-container {
  width: 500px;
  height: 500px;
  margin: 40px auto 0;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
